import { useEffect } from 'react';
import useLocalStorage from 'use-local-storage';

function useTheme() {
  const [theme] = useLocalStorage<string | null>('theme', null);

  useEffect(() => {
    function checkTheme() {
      if (theme) {
        document.getElementsByTagName('body')[0].classList.add(theme);
      }
    }

    checkTheme();
  }, [theme]);
}

export default useTheme;
